(function(){
  var KEY = 'cc_wishlist';

  function read(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; }
  }
  function write(list){
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
    document.dispatchEvent(new CustomEvent('cc:wishlist-change', {detail:{list:list}}));
  }
  function has(handle){ return read().indexOf(handle) > -1; }
  function toggle(handle){
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    return list.indexOf(handle) > -1;
  }
  window.ccWishlist = {read:read, has:has, toggle:toggle};

  var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 19.5c-4.8-3.1-9-6.4-9-10.7C3 5.9 5.3 4 7.9 4c1.7 0 3.3.9 4.1 2.4C12.8 4.9 14.4 4 16.1 4 18.7 4 21 5.9 21 8.8c0 4.3-4.2 7.6-9 10.7z"/></svg>';
  // Header heart only: matches the native header icon family exactly (20x20 viewBox,
  // rounded stroke caps/joins, var(--icon-stroke-width)) — same conventions as
  // assets/icon-cart.svg — instead of reusing the card heart's own proportions/weight.
  var HEART_HEADER = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M10 16.5c-.28 0-.55-.1-.76-.3l-4.8-4.4C2.98 10.4 2.3 8.9 2.3 7.3 2.3 4.93 4.17 3 6.5 3c1.3 0 2.52.6 3.5 1.6C10.98 3.6 12.2 3 13.5 3c2.33 0 4.2 1.93 4.2 4.3 0 1.6-.68 3.1-2.14 4.5l-4.8 4.4c-.21.2-.48.3-.76.3z"/></svg>';

  function badge(){
    var count = read().length;
    document.querySelectorAll('.cc-wl-count').forEach(function(el){
      el.textContent = count > 0 ? count : '';
      el.hidden = count === 0;
    });
  }

  function paintCard(card){
    var handle = card.dataset.ccHandle;
    if (!handle) return;
    var btn = card.querySelector('.cc-wl-btn');
    if (!btn) return;
    btn.classList.toggle('is-on', has(handle));
  }

  function wireCard(card){
    if (card.__ccWl) { paintCard(card); return; }
    card.__ccWl = 1;
    var handle = card.dataset.ccHandle;
    if (!handle) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-wl-btn';
    btn.setAttribute('aria-label', 'Save to wishlist');
    btn.innerHTML = HEART;
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var on = toggle(handle);
      btn.classList.toggle('is-on', on);
      btn.classList.add('cc-wl-pop');
      setTimeout(function(){ btn.classList.remove('cc-wl-pop') }, 260);
    });
    var frame = card.querySelector('.cc-card__frame') || card;
    frame.appendChild(btn);
    paintCard(card);
  }

  function scan(root){
    (root || document).querySelectorAll('.cc-card[data-cc-handle]').forEach(wireCard);
  }

  function injectHeaderIcon(){
    if (document.querySelector('.cc-wl-header')) return;
    var cartIcon = document.querySelector('cart-icon');
    if (!cartIcon) return;
    // cart-icon's own parent is the cart-drawer trigger <button> — insert as a
    // sibling of that button, not inside it (an <a> inside a <button> is invalid
    // and inherits the button's own color transition, causing a visible lag).
    var cartButton = cartIcon.closest('.header-actions__action') || cartIcon.parentElement;
    var mount = cartButton.parentElement;
    var a = document.createElement('a');
    var qs = '';
    var params = new URLSearchParams(window.location.search);
    if (params.get('preview_theme_id')) qs = '?preview_theme_id=' + params.get('preview_theme_id');
    a.href = '/pages/wishlist' + qs;
    a.className = 'cc-wl-header';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = HEART_HEADER + '<span class="cc-wl-count" hidden></span>';
    mount.insertBefore(a, cartButton);
    badge();
  }

  document.addEventListener('cc:wishlist-change', badge);

  if (document.readyState !== 'loading') { scan(document); injectHeaderIcon(); badge(); }
  else document.addEventListener('DOMContentLoaded', function(){ scan(document); injectHeaderIcon(); badge(); });
  if (window.ccOnDomChange) window.ccOnDomChange(function(){ scan(document); injectHeaderIcon(); badge(); }, 30);
})();
